import { FC, useEffect } from 'react';
import { Addresses } from "../../../constants/Addresses";
import Chains from "../../../constants/wagmi/chains";
import { useAppDispatch } from '../../hooks';
import { useFetchTokenDataQuery } from '../actions';
import { setTokenPrice } from '../reducer';
import { SetTokenPricePayload } from '../types';

const GlobalMagicUpdater: FC = (): null => {
  const dispatch = useAppDispatch();
  const { data, error, isLoading } = useFetchTokenDataQuery(Addresses[Chains.avalanche.id].Tokens.MAGIC, { pollingInterval: 60000 });

  useEffect(() => {
    if (error) {
      console.log('Error fetching Token Data:', error);
      return;
    }
    if (!isLoading && data) {
      const MAGIC: SetTokenPricePayload = {
        token: 'MAGIC',
        details: {
          price: Number(data.priceUsd),
          liquidity: Number(data.liquidity.usd),
        },
      };
      const xMAGIC = { ...MAGIC, token: 'xMAGIC' };

      dispatch(setTokenPrice(MAGIC));
      dispatch(setTokenPrice(xMAGIC));
    }
  }, [data]);

  return null;
};

export default GlobalMagicUpdater;
